import { font } from "./font";
import { fontbold } from "./font_bold";
import { fontitalic } from "./font_italic";
import { fontbolditalic } from "./font_bolditalic";

const Jspdf_font = (doc) =>{
    doc.addFileToVFS("./fonts-rebranding/GE-BodyCopy.ttf", font);
    doc.addFileToVFS("./fonts-rebranding/GE-BodyCopyHighlight.ttf", fontbold);
     doc.addFileToVFS("./fonts-rebranding/GE-BodyCopyHighlightItalic.ttf", fontbolditalic);
    doc.addFileToVFS("./fonts-rebranding/GE-BodyCopyItalic.ttf", fontitalic);
    doc.addFont("./fonts-rebranding/GE-BodyCopy.ttf", "GE-BodyCopy", "normal");
    doc.addFont("./fonts-rebranding/GE-BodyCopyHighlight.ttf", "GE-BodyCopyHighlight", "bold");
    doc.addFont("./fonts-rebranding/GE-BodyCopyItalic.ttf", "GE-BodyCopyItalic", "italic");
   doc.addFont( "./fonts-rebranding/GE-BodyCopyHighlightItalic.ttf", "GE-BodyCopyHighlightItalic", "bolditalic");

     // Register fallback fonts with proper variants
     doc.addFont("helvetica", "Helvetica", "normal");
     doc.addFont("helvetica", "Helvetica-Bold", "bold");
     doc.addFont("helvetica", "Helvetica-Oblique", "italic");
     doc.addFont("times", "Times", "normal");
     doc.addFont("times", "Times-Bold", "bold");
     
     doc.setFont("GE-BodyCopy", "normal");
     return doc
}
export default Jspdf_font;